import React, { memo } from "react";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

const TabPanel = memo((props) => {
    const { children, value, index, className, padding } = props;

    return (
        <div
            className={className}
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
        >
            {value === index && <Box sx={{ p: padding }}>{children}</Box>}
        </div>
    );
});

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  padding: PropTypes.number,
};

TabPanel.defaultProps = {
    padding: 3,
}

export default TabPanel;
